import type { ReactNode } from 'react';
import { ShieldCheck, ShieldOff } from 'lucide-react';
import { Badge } from '@voll-intelligence/ui-kit/ui/badge';

/**
 * **O selo de política com PALAVRA** — o par do `OutOfPolicyMark`, para onde a
 * política é uma afirmação do documento e não um marcador de lista: recibo de
 * hotel, recibo de voo, total do voucher, veredito do drawer de regras.
 *
 * Um só primitivo, o `Badge soft` do DS: ele já fixa a altura (`h-5`), o
 * `nowrap`, o `w-fit` e o slot de ícone em 12px (`[&>svg]:size-3!`), então nem o
 * tamanho do glifo nem a largura são decisão de chamador. Sem `align-self`: o
 * `w-fit` já impede o esticão em coluna flex, e um `self-start` fixo empurraria o
 * selo para o topo nas linhas `align-items: center` (cabeçalho do checkout).
 *
 * Glifos: escudo íntegro no conforme, escudo CORTADO na exceção — nunca o
 * triângulo de alerta, nunca âmbar. Âmbar é urgência; furo de política é
 * `danger`, a mesma tinta do marcador.
 *
 * Quando NÃO usar: em lista de ofertas, onde a política é a exceção de um item
 * entre vários — lá vale o `OutOfPolicyMark`, sem palavra, e o conforme fica em
 * silêncio.
 */
export function PolicyBadge({
  label,
  tone,
}: {
  readonly label: string;
  readonly tone: 'within' | 'outside';
}): ReactNode {
  const within = tone === 'within';
  return (
    // `w-max`, não o `w-fit` do primitivo: `fit-content` CEDE ao espaço
    // disponível, e num cabeçalho apertado o selo entregava a largura do glifo
    // (medido: svg em 0px de largura no card de cotação, escudo invisível). Com
    // `max-content` a palavra e o escudo mantêm a caixa e quem cede é o título.
    <Badge variant="soft" color={within ? 'success' : 'danger'} className="w-max">
      {within ? <ShieldCheck aria-hidden /> : <ShieldOff aria-hidden />}
      {label}
    </Badge>
  );
}
